import { SUPPORTED_LANGUAGES } from '@atlaskit/code/constants';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { EditorState, Transaction } from '@atlaskit/editor-prosemirror/state';
import {
  ReplaceAroundStep,
  ReplaceStep,
} from '@atlaskit/editor-prosemirror/transform';
import { getLanguage } from '@atlassian/bitkit-code';

import type { Config } from './index';

export const createPlugin = (config: Config): SafePlugin =>
  new SafePlugin({
    appendTransaction: (
      transactions: Transaction[],
      _oldState: EditorState,
      newState: EditorState
    ) => {
      let tr: Transaction | null = null;
      const language = config?.filePath
        ? getLanguage(config?.filePath)?.prism
        : undefined;

      if (
        !language ||
        !SUPPORTED_LANGUAGES.some(l => l.alias[0] === language)
      ) {
        return tr;
      }

      transactions.forEach(transaction => {
        transaction.steps.forEach(step => {
          if (
            !(step instanceof ReplaceAroundStep || step instanceof ReplaceStep)
          ) {
            return;
          }
          step.slice.content.forEach(newNode => {
            if (newNode.type.name !== 'codeBlock') {
              return;
            }
            newState.doc.descendants((node, pos) => {
              if (node !== newNode || node.attrs.language !== null) {
                return true;
              }
              if (!tr) {
                ({ tr } = newState);
              }
              tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                language,
              });
              return false;
            });
          });
        });
      });
      return tr;
    },
  });
